/* eslint react/prop-types: 0 */
import React from "react";
import { navigate } from "gatsby";
import _ from "lodash";

import { createPaginatedData, itemsPerPage } from "../helpers/createPage";
import { compareObjects } from "../helpers/helper";

class SearchProperties extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      searchForm: {
        search: "",
        category: "",
        type: "",
        bedrooms: "",
        bathrooms: "",
        sort_column: "",
        sort_order: "",
      },
    };
  }

  componentDidMount() {
    this.filterProperties();
  }

  handleInputChange = (event) => {
    const { name, value } = event.target;
    const { searchForm } = this.state;
    searchForm[name] = value;
    this.setState({
      searchForm: searchForm,
    });
  };

  handleSortChange(event) {
    const { value } = event.target;
    const [column, order] = value.split("-");
    const { searchForm } = this.state;
    searchForm["sort_column"] = column;
    searchForm["sort_order"] = order;
    this.setState({
      searchForm: searchForm,
    });
    this.searchProperties();
  }

  clearSearchForm() {
    let { search } = this.props.location;
    if (search) {
      navigate(`/${this.props.navigationPrefix}`);
    }
  }

  searchProperties() {
    const { search } = this.props.location;
    let searchParams = Object.fromEntries(new URLSearchParams(search));
    searchParams = _.omit(searchParams, ['latitude', 'longitude', 'swl_lng', 'sw_lat', 'ne_lng', 'ne_lat', 'zoom']);
    if (!compareObjects(searchParams, this.state.searchForm)) {
      if (Object.values(this.state.searchForm).filter((val) => Boolean(val)).length == 0) {
        this.clearSearchForm();
      } else {
        let queryString = new URLSearchParams(this.state.searchForm).toString();
        navigate(`/${this.props.navigationPrefix}?${queryString}`);
      }
    }
  }

  filterProperties() {
    let { properties, locale, location, navigationPrefix } = this.props;
    let { search, pathname } = location;

    let searchObj = Object.fromEntries(new URLSearchParams(search));

    let searchForm = {};
    let searched = false;

    /** search by text */
    if (searchObj.search) {
      let searchInput = searchObj.search.toLowerCase();
      properties = properties.filter((property) => {
        if (
          property.city &&
          property.city.toLowerCase().indexOf(searchInput) !== -1
        ) {
          return true;
        }

        if (
          property.district &&
          property.district.toLowerCase().indexOf(searchInput) !== -1
        ) {
          return true;
        }

        if (
          property.state &&
          property.state.toLowerCase().indexOf(searchInput) !== -1
        ) {
          return true;
        }

        if (
          property.country &&
          property.country.country_name &&
          property.country.country_name.toLowerCase().indexOf(searchInput) !==
            -1
        ) {
          return true;
        }

        let translation = _.find(property.translations, { locale: locale });
        if (
          translation &&
          translation.headline &&
          translation.headline.toLowerCase().indexOf(searchInput) !== -1
        ) {
          return true;
        }

        if (_.find(property.propertyTag, { name: searchInput })) {
          return true;
        }
      });
      searchForm.search = searchInput;
      searched = true;
    }

    /** search by category */
    if (searchObj.category) {
      properties = properties.filter(
        (property) => property.category && property.category.id == searchObj.category
      );
      searchForm.category = searchObj.category;
      searched = true;
    }

    /** search by property type */
    if (searchObj.type) {
      properties = properties.filter(
        (property) =>
          property.property_type && property.property_type.id == searchObj.type
      );
      searchForm.type = searchObj.type;
      searched = true;
    }

    /** search by bedrooms */
    if (searchObj.bedrooms) {
      let bedroomsInput = parseInt(searchObj.bedrooms);
      properties = properties.filter((property) => {
        return (
          (bedroomsInput < 4 && property.bedrooms === bedroomsInput) ||
          (bedroomsInput >= 4 && property.bedrooms >= 4)
        );
      });
      searchForm.bedrooms = bedroomsInput;
      searched = true;
    }

    /** search by bathrooms */
    if (searchObj.bathrooms) {
      let bathroomsInput = parseInt(searchObj.bathrooms);
      properties = properties.filter((property) => {
        return (
          (bathroomsInput < 4 && property.bathrooms === bathroomsInput) ||
          (bathroomsInput >= 4 && property.bathrooms >= 4)
        );
      });
      searchForm.bathrooms = bathroomsInput;
      searched = true;
    }

    let { center_lat: latitude, center_lng: longitude } = searchObj;
    const { sw_lng, sw_lat, ne_lng, ne_lat } = searchObj;
    if (latitude && longitude && sw_lng && sw_lat && ne_lng && ne_lat) {
      properties = properties.filter((property) => {
        return (
          (sw_lat < ne_lat && property.latitude >= sw_lat && property.latitude <= ne_lat) ||
          (sw_lat > ne_lat && property.latitude >= sw_lat && property.latitude <= ne_lat)
        );
      });

      properties = properties.filter((property) => {
        return (
          (sw_lng < ne_lng && property.longitude >= sw_lng && property.longitude <= ne_lng) ||
          (sw_lng > ne_lng && property.longitude >= sw_lng && property.longitude <= ne_lng)
        );
      });

      searched = true;
    }

    /** sort properties */
    if (searchObj.sort_column && searchObj.sort_order) {
      let sortColumn = searchObj.sort_column;
      let sortOrder = searchObj.sort_order;
      if (sortColumn == "created_at" || sortColumn == "updated_at") {
        properties.sort(function compare(property1, property2) {
          let date1 = new Date(property1[sortColumn]);
          let date2 = new Date(property2[sortColumn]);
          return sortOrder == "asc" ? date1 - date2 : date2 - date1;
        });
      } else {
        properties = _.orderBy(
          properties,
          [(el) => el[sortColumn] || ""],
          [sortOrder]
        );
      }
      searchForm.sort_column = sortColumn;
      searchForm.sort_order = sortOrder;
      searched = true;
    }

    let paginatedData = null;
    if (searched) {
      let page = pathname.replace(`/${navigationPrefix}`, "").replace("/", "");
      paginatedData = createPaginatedData(
        properties,
        itemsPerPage,
        page ? parseInt(page) : 1
      );

      this.props.setProperties(properties, paginatedData);

      this.setState({
        searchForm: { ...this.state.searchForm, ...searchForm },
      });
    }
    
    if (!latitude || !latitude) {
      if (paginatedData) {
        const property = paginatedData.data.find(el => el.latitude && el.longitude);
        latitude = property?.latitude;
        longitude = property?.longitude;
      } else {
        const property = properties.find(el => el.latitude && el.longitude);
        latitude = property?.latitude;
        longitude = property?.longitude;
      }
    }

    if (this.props.setMapOptions) {
      this.props.setMapOptions(latitude, longitude, searchObj.zoom)
    }
  }
}

export default SearchProperties;
